import React, { useState, useEffect, useRef } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Stack,
  TextField,
  Button,
  Grid,
  Typography,
  Card
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { trackPromise } from 'react-promise-tracker';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import _ from 'lodash';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import LoadingButton from '@mui/lab/LoadingButton';
import CreatePDF from './CreatePDF';
import ReactToPrint from 'react-to-print';
import xlsx from 'json-as-xlsx';
import { makeStyles } from '@material-ui/styles';
import { CustomTable } from './CustomTable';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

var screenCode = 'VIEWCUSTOMERORDERSOUTLETWISE';

export default function ViewCustomerOrdersOutletWise(props) {
  const classes = useStyles();
  const componentRef = useRef();
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [csvHeaders, SetCsvHeaders] = useState([]);

  const navigate = useNavigate();
  const [date, setDate] = useState(new Date());
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: 0,
    factoryID: 0,
    date: ''
  });

  const [totalValues, setTotalValues] = useState({
    totalFullfilled: 0,
    totalQtyKG: 0,
    totalQtyUnit: 0,
    remainingQty: 0,
    fulfilledSumKg: 0,
    fulfilledSumUnit: 0,
    remainingKG: 0,
    remainingUnit: 0,
    shortSupplyAmount: 0
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: '',
    factoryID: '',
    date: ''
  });

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    factoryID: Yup.number().notRequired(),
    date: Yup.date().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      factoryID: formData.factoryID,
      date: formData.date
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    }
  });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWCUSTOMERORDERSOUTLETWISESCREEN');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
    });
    trackPromise(GetAllGroups());
  }

  useEffect(() => {
    trackPromise(GetOutletByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    setTableData([]);
  }, [date]);

  useEffect(() => {
    if (tableData.length != 0) {
      calculateTotalQty();
    }
  }, [tableData]);

  async function GetAllGroups() {
    var res = await services.GetAllGroups();
    if (res != null) {
      setGroup(res);
    }
  }

  async function GetOutletByGroupID() {
    var res = await services.GetOutletByGroupID(formik.values.groupID);
    if (res != null) {
      setFactory(res);
    }
  }

  async function SubmitForm(value) {
    setTableData([]);
    var result = await services.GetCustomerOrdersOutletWiseDetails(formik.values.factoryID, date.toISOString());
    trackPromise(CheckOutletWiseCustomerOrders());
    let newRes = _.cloneDeep(result);
    newRes.forEach((x) => {
      if (x.measuringUnit == 1) {
        x.measuringUnitName = x.measuringGram == 0 ? 'Unit' : 'Unit ' + x.measuringGram + 'G';
      } else if (x.measuringUnit == 2) {
        x.measuringUnitName = 'KG';
      } else if (x.measuringUnit == 3) {
        x.measuringUnitName = 'G';
      } else {
        x.measuringUnitName = '';
      }
    });
    setTableData(newRes);
  }

  function calculateTotalQty() {
    const totalKG = tableData
      .filter((item) => item.measuringUnit === 2)
      .reduce((accumulator, current) => accumulator + current.quantity, 0);
    const totalUnit = tableData
      .filter((item) => item.measuringUnit === 1)
      .reduce((accumulator, current) => accumulator + current.quantity, 0);
    const sum = tableData.reduce((accumulator, current) => accumulator + current.quantity, 0);
    const fulfilledSumKg = tableData
      .filter((item) => item.measuringUnit === 2)
      .reduce((accumulator, current) => accumulator + current.fulfilledQuantity, 0);
    const fulfilledSumUnit = tableData
      .filter((item) => item.measuringUnit === 1)
      .reduce((accumulator, current) => accumulator + current.fulfilledQuantity, 0);
    const remainingKG = totalKG - fulfilledSumKg;
    const remainingUnit = totalUnit - fulfilledSumUnit;
    setTotalValues({
      ...totalValues,
      totalQtyKG: totalKG,
      totalQtyUnit: totalUnit,
      fulfilledSumKg: fulfilledSumKg,
      fulfilledSumUnit: fulfilledSumUnit,
      remainingKG: remainingKG,
      remainingUnit: remainingUnit
    });
  }

  async function generatePerformOrder() {
    setIsLoading(true);
    var res = await services.GeneratePerformOrderOutletWise(parseInt(TokenDecoder.getUserIDFromToken()), date.toISOString());
    if (res.statusCode === 'Success') {
      toast.success(res.message);
      trackPromise(CheckOutletWiseCustomerOrders());
      setIsLoading(false);
    } else {
      toast.error(res.message);
    }
  }

  async function CheckOutletWiseCustomerOrders() {
    const res = await services.CheckOutletWiseCustomerOrders(date.toISOString());
    var ress1 = res[0].isMainOrder;
    if (ress1 != undefined) {
      setIsDisabled(ress1);
    } else {
      setIsDisabled(false);
    }
  }

  function getSelectedDropdownValuesForReport() {
    let groupData = group.find((x) => x.groupID == formik.values.groupID);
    setSelectedSearchValues({
      ...selectedSearchValues,
      date: formik.values.date,
      groupID: groupData.groupName
    });
  }

  async function createFile() {
    var file = await createDataForExcel(tableData);
    var settings = {
      sheetName: 'Customer Orders Outlet Wise',
      fileName: 'Outlet Order Allocation',
      writeOptions: {}
    };
    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    let dataA = [
      {
        sheet: 'Outlet Order Allocation',
        columns: tempcsvHeaders,
        content: file
      }
    ];
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array.length != 0) {
      array.map((x) => {
        var vr = {
          Outlet: x.factoryName,
          SKU: x.productCode,
          'Crop Name': x.productName,
          Quantity: x.quantity.toFixed(2),
          'Fullfilled Quantity': x.fulfilledQuantity.toFixed(2),
          'Measuring Unit': x.measuringUnitName
        };
        res.push(vr);
      });

      res.push({});
      res.push({});

      var vr1 = {
        SKU: 'Group: ' + selectedSearchValues.groupID,
        'Crop Name': 'Date : ' + date.toISOString().split('T')[0]
      };
      res.push(vr1);

      var vr1 = {
        SKU: 'Total Orders: ' + tableData.length,
        'Crop Name':
          'Total Quantity : ' +
          totalValues.totalQtyKG.toFixed(2) +
          '(KG) | ' +
          totalValues.totalQtyUnit.toFixed(2) +
          '(UNIT)',
        Quantity:
          'Total Fulfilled Quantity : ' +
          totalValues.fulfilledSumKg.toFixed(2) +
          '(KG) | ' +
          totalValues.fulfilledSumUnit.toFixed(2) +
          '(UNIT)',
        'Fullfilled Quantity':
          'Total Remaining Quantity : ' +
          totalValues.remainingKG.toFixed(2) +
          '(KG) | ' +
          totalValues.remainingUnit.toFixed(2) +
          '(UNIT)'
      };
      res.push(vr1);
    }
    return res;
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <>
      <LoadingComponent />
      <Page title="Customer Order Outlet Wise view |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/viewCustomerOrdersOutletWise'}
            btname="Add"
            pageName="View Customer Orders Outlet Wise"
            leftButtonHidden={true}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: true
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Group
                    </MenuItem>
                    {group.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.groupID} value={option.groupID}>
                          {option.groupName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Outlet "
                    value={formik.values.factoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('factoryID')}
                    error={Boolean(touched.factoryID && errors.factoryID)}
                    helperText={touched.factoryID && errors.factoryID}
                  >
                    <MenuItem key={0} value={0}>
                      All Outlet
                    </MenuItem>
                    {factory.map((option) =>
                      <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem>
                    )}
                  </TextField>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Select Date *"
                      value={date}
                      onChange={(newValue) => {
                        setDate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          size="small"
                          {...getFieldProps('date')}
                          error={Boolean(touched.date && errors.date)}
                          helperText={touched.date && errors.date}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
              <br />
            </Form>
          </FormikProvider>
          <br />
          {tableData.length != 0 ? (
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Grid item md={12} xs={12} style={{ border: '2px solid green', borderRadius: 50 }}>
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Total Orders : ' + tableData.length}
                    </Typography>
                  </center>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  style={{ border: '2px solid green', borderRadius: 50, marginTop: '10px' }}
                >
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Total Fulfilled Quantity : ' +
                        totalValues.fulfilledSumKg.toFixed(3) +
                        ' (KG) | ' +
                        totalValues.fulfilledSumUnit.toFixed(3) +
                        ' (UNIT)'}
                    </Typography>
                  </center>
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Grid item md={12} xs={12} style={{ border: '2px solid green', borderRadius: 50 }}>
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Total Quantity : ' +
                        totalValues.totalQtyKG.toFixed(3) +
                        ' (KG) | ' +
                        totalValues.totalQtyUnit.toFixed(3) +
                        ' (UNIT)'}
                    </Typography>
                  </center>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  style={{ border: '2px solid green', borderRadius: 50, marginTop: '10px' }}
                >
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Remaining Quantity : ' +
                        totalValues.remainingKG.toFixed(3) +
                        ' (KG) | ' +
                        totalValues.remainingUnit.toFixed(3) +
                        ' (UNIT)'}
                    </Typography>
                  </center>
                </Grid>
              </Grid>
            </Grid>
          ) : null}
          <br />
          {tableData.length != 0 ? (
            <>
              <br />
              <Card>
                <CustomTable tableData={tableData} />
              </Card>
              <br />
              <Divider variant="middle" />
              &nbsp;
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="right">
                <Button
                  color="primary"
                  id="btnRecord"
                  type="submit"
                  variant="contained"
                  className={classes.colorRecord}
                  onClick={() => createFile()}
                >
                  EXCEL
                </Button>
                <ReactToPrint
                  documentTitle={'Order Allocation Details Report'}
                  trigger={() => (
                    <Button
                      color="primary"
                      id="btnRecord"
                      type="submit"
                      variant="contained"
                      style={{ backgroundColor: 'red' }}
                      onClick={() => getSelectedDropdownValuesForReport()}
                    >
                      PDF
                    </Button>
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePDF
                    ref={componentRef}
                    tableData={tableData}
                    searchData={selectedSearchValues}
                    date={date}
                    totalValues={totalValues}
                  />
                </div>
                <LoadingButton
                  type="button"
                  color="secondary"
                  disabled={isDisabled}
                  loading={isLoading}
                  variant="outlined"
                  onClick={() => trackPromise(generatePerformOrder())}
                >
                  Generate Perform Order
                </LoadingButton>
              </Stack>
            </>
          ) : (
            <SearchNotFound searchQuery="View Customer Orders Outlet Wise" />
          )}
        </Container>
      </Page>
    </>
  );
}
